<style lang="scss" src='./Order.scss' scoped></style>
<template src="./Order.html"></template>

<script>
  import {
    mapState,
    mapActions,
    mapMutations
  } from "vuex";
  import moment from 'moment';
  import InputMap from '@/components/inputMap/InputMap';
  import DeleteOrderModal from '@/components/deleteOrderModal/DeleteOrderModal';
  import StarsRaiting from '@/components/starsRaiting/StarsRaiting';
  import ReviewOrderModal from "@/components/reviewOrderModal/ReviewOrderModal.vue";
  export default {
    name: "Order",
    components: {
      InputMap,
      DeleteOrderModal,
      StarsRaiting,
      ReviewOrderModal,
    },
    data() {
      return {
        selected: null,
        loading: {
          to_cart: false,
        },
      };
    },
    computed: {
      ...mapState(['user', 'orderList']),
      ...mapState('Main', ['categorysList']),
      ...mapState('CartStore', ['cartProducts']),
      orderDetails() {
        return this.orderList.find(order => order._id == this.$route.params.orderId) || {};
      },

      orderStatus() {
        switch (this.orderDetails.status) {
          case 'PROCESSING':
            return this.$t('order.status.preparing');
          case 'READY':
            return this.$t('order.status.ready');
          case 'OUT_FOR_DELIVERY':
            return this.$t('order.status.delivering');
          case 'DELIVERED':
            return this.$t('order.status.delivered');
          case 'CANCELED':
            return this.$t('order.status.canceled');
          case 'RETURNED':
            return this.$t('order.status.returned');
          default:
            return this.$t('order.status.placed');
        }
      },

      showDiscount() {
        return this.orderDetails.coupon_id;
      },
    },

    methods: {
      ...mapActions('CartStore', ['fnApiPreviousOrder']),
      ...mapActions(['fnApiDeleteOrder']),

      fnGetDate() {
        let {
          date,
          start_time
        } = this.orderDetails.delivery_method.delivery_time;
        return this.F_formatDateWithString(date + ' ' + start_time, 'hh:mm A -  dddd DD/MMMM/YYYY ');
      },

      fnOrderDate() {
        let {
          time_purchased
        } = this.orderDetails;
        return this.F_formatDateWithString(time_purchased, ' DD/MMMM/YYYY');
      },

      async fnReorder() {
        let condition = true;
        if (this.cartProducts.products.length > 0) {
          condition = await this.$bvModal.msgBoxConfirm(this.$t('general.reorderConfirmation'), {
            title: this.$t('general.confirmation'),
            size: 'md',
            buttonSize: 'md',
            okVariant: 'success',
            okTitle: this.$t('general.yes'),
            cancelTitle: this.$t('general.no'),
            centered: true
          });
        }
        if (condition) {
          this.loading.to_cart = true;
          await this.fnApiPreviousOrder(this.orderDetails._id);
          this.loading.to_cart = false;
        }

      },

      fnGetCategory(categoryId) {
        return this.categorysList.find(category => category.category_id == categoryId);
      },
      fnCancelOrder() {
        this.$refs['deleteOrder'].orderId = this.orderDetails._id;
        this.$refs['deleteOrder'].showModal = true;
      },
      fnRedirect() {
        this.$router.push('/dashboard/account')
      },

      fnGetOrderStatusPillColor(order){
        switch (order.status) {
          case 'PROCESSING':
            return 'info';
          case 'READY':
            return 'orange';
          case 'OUT_FOR_DELIVERY':
            return 'purple';
          case 'DELIVERED':
            return 'success';
          case 'CANCELED':
            return 'gray';
          case 'RETURNED':
            return 'gray';
          default:
            return 'warning';
        }
      },

      fnOrderReview() {
        this.$refs['reviewOrderModal'].orderInfo = {...this.orderDetails};
        this.$refs['reviewOrderModal'].showModal = true;
      },
      fnShowRipeness(product) {
        if(product){
          switch(product.ripeness){
            case 0:
              return this.$t('general.green');
            case 2:
              return this.$t('general.mature');
            default:
              return this.$t('general.intermediate');
          }
        }
      },
      fnShowProductDiscount(product){
        if(this.orderDetails.coupon && this.orderDetails.coupon.type && this.orderDetails.coupon.type == 'PERCENTAGE'){
          let cat_id = this.orderDetails.coupon.category_id;
          if(cat_id == null || product.category_id == cat_id){
            let discount = 0;
            let amount = this.orderDetails.coupon.amount;
            discount = product.subtotal * (amount / 100);
            return this.F_formatPrice(discount);
          }
        }
        return '';
      },
    },

    beforeCreate() {},
    created() {
      window.fbq('track', 'PageView');
    },
    mounted() {},
    beforeDestroy() {},
  };

</script>
